import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitch, FaYoutube, FaTwitter, FaInstagram, FaTiktok } from 'react-icons/fa';
import { LEGAL_PAGES } from '../config/legalConfig';
import styles from './Footer.module.css';

const Footer = ({ fixed }) => {
  return (
    <footer className={`${styles.footer} bg-gray-800 text-white p-4 mt-8 dark:bg-gray-900 dark:text-white ${fixed ? styles['footer--fixed'] : ''}`}>
      <div className={`${styles.footerContainer} container mx-auto`}>
        <div className="flex justify-center space-x-6 mb-2">
          <a href="https://www.twitch.tv/Don_Diegons" aria-label="Twitch" target="_blank" rel="noopener noreferrer" className="text-white hover:text-purple-400 transition-colors duration-300">
            <FaTwitch size={24} />
          </a>
          <a href="https://www.youtube.com/channel/UCTzYVL_jYgMFrf2iz8V2HFw" aria-label="YouTube" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-500 transition-colors duration-300">
            <FaYoutube size={24} />
          </a>
          <a href="https://twitter.com/Don_Diegons" aria-label="X (Twitter)" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors duration-300">
            <FaTwitter size={24} />
          </a>
          <a href="https://www.instagram.com/Don_Diegons/" aria-label="Instagram" target="_blank" rel="noopener noreferrer" className="text-white hover:text-pink-500 transition-colors duration-300">
            <FaInstagram size={24} />
          </a>
          <a href="https://www.tiktok.com/@don_diegons" aria-label="TikTok" target="_blank" rel="noopener noreferrer" className="text-white hover:text-black dark:hover:text-white transition-colors duration-300">
            <FaTiktok size={24} />
          </a>
        </div>
        <div className={styles.footerText}>
          <span>&copy; {new Date().getFullYear()} Diegoncurso. Todos los derechos reservados.</span>
          <nav aria-label="Información legal" className={styles.legalLinks}>
            {LEGAL_PAGES.map((p) => (
              <Link key={p.to} to={p.to} className="text-gray-300 hover:text-white hover:underline">{p.label}</Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
